
  <script>
    import { onMount } from "svelte";
    import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
    import backend from "../../../../../server";
    import Toaster from './Toaster.svelte';
    import DetailPlayer from './DetailPlayer.svelte'

    export let campaign;  
    export let isModalPlayer =false ;

    let isLoading = false;

    let filter ={page:1,limit:10,id:''}
    let type = false; 
    let message = []; 
    let toastMessage='';
    let players = []; 
    let selectedPlayers = [];
    let isShowToast=false;
    let isDelete = {}; 
    let isdetail=false;
    let campaignId=''
    let playerId=''


    const closeModal = () => {
        isModalPlayer = false;  
       
    };

const toggleSelect = (id) => {
    selectedPlayers = selectedPlayers.includes(id) 
        ? selectedPlayers.filter(item => item !== id) 
        : [...selectedPlayers, id]; 
}

const validateCampaign = () => {
    let isValid = true;
    let playes = { ids: [...selectedPlayers] };
    if (playes.ids.length === 0) {
      toastMessage = 'Seleccione al menos un juador.';
      isValid = false;
    }
    return { isValid, toastMessage ,playes};
};

const savePlayers = async () => {
  var { isValid, toastMessage,playes } = validateCampaign();
    if (!isValid) {
      isShowToast= true
      return;
    }
    isLoading = true;
    try {
      let response = await backend.freespin.saveAddPlayerCampaign(playes, campaign.id);
      if(response.data.status) {
        type = (response.data.status) ? true: false;
          toastMessage = 'Players added successfully';
          getPlayesByCampaing(filter); // Recargar lista
          selectedPlayers = []; 
      } else {
          toastMessage = response.data.messages.join(', ');
      }
        
    } catch (error) {
        toastMessage = error.message;
    } finally {
        isLoading = false;
        isShowToast = true;
    }
};

  


    onMount(async () => {
      filter = { ...filter, id: campaign.id };
        await getPlayesByCampaing(filter);
        
     });
   const getPlayesByCampaing = async(filter)=>{
    try {
        let response = await backend.freespin.getPlayesByCampaing(filter);
        players =response.data.data.players;
    
    } catch (error) {
      toastMessage= error.messenger
    }
   }

   const removePlayerOffCampaign = async (player_id) => {
    isDelete[player_id] = true;
 
    try {
      let response = await backend.freespin.removePlayerOffCampaign({id :campaign.id ,player_id: player_id});

      message = response.data.messages.length > 0 ? response.data.messages : ['Players were successfully added.'];
      type = true
      toastMessage= 'Players were successfully added.';
      isShowToast = true
      getPlayesByCampaing(filter);
    } catch (error) {
      type=false
      toastMessage=error.message
     
    } finally {

      isDelete[player_id] = false;
    showAlert = true;
}
};

const details = async (player_id) => {
  isdetail=false
  campaignId =campaign.id
  playerId =player_id
  console.log(playerId)
  isdetail = true;
};

   let playersStatic = [
      {id:28536,player_id:18725553, clientcode:'JU02',username:'1507958907009',balance:500.75,firstname:'demo12',siteid:'TOMCAT00023423',username_origin:'demo12',serial:'1507958907009',currency:'USD',client_id:44},
      {id:28538,player_id:18725554, clientcode:'JU02',username:'3807515988447',balance:1020.50,firstname:'demo13',siteid:'TOMCAT00023423',username_origin:'demo13',serial:'3807515988447',currency:'USD',client_id:44},
      {id:28534,player_id:18725555,clientcode:'JU02',username:'1614668906362',balance:750.30,firstname:'demo14',siteid:'TOMCAT00023423',username_origin:'demo14',serial:'1614668906362',currency:'USD',client_id:44},
      {id:8113,player_id:18725556,clientcode:'GOLD',username:'4712080194222',balance:695.66,firstname:'casinoUSD',siteid:'21GOLDENBET4A190',username_origin:'casinoUSD',serial:'4712080194222',currency:'USD',client_id:31},
      {id:28531,player_id:18725557,clientcode:'JU02',username:'3892419797047',balance:14358.71,firstname:'Carlo',siteid:'TOMCAT00023423',username_origin:'casinoUSD',serial:'3892419797047',currency:'USD',client_id:44},
      {id:28532, player_id: 99999999, clientcode: 'JU02', username: '2860967228690', balance: 14358.71, firstname: 'Vrtx', siteid: 'TOMCAT00023423', username_origin: 'Vrtx', serial: '2860967228690', currency: 'USD', client_id: 44}
    ];



// Función para seleccionar/deseleccionar una fila

</script>
  <Modal isOpen={isModalPlayer} toggle={closeModal} size="xl">
    <ModalHeader toggle={closeModal}>
      Agregar jugadores en la campaña {campaign.client_campaign_title}
    </ModalHeader>
    <ModalBody>

    
      
      <table class="table table-sm" style="width: 100%;">
        <thead>
          <tr>
            <th>N°</th>
            <th>id external</th>
            <th>Username</th>
            <th>Username_origin</th>
            <th>Currency</th>
            <th style="text-align: center;" >seleccionado</th>
          </tr>
        </thead>
        <tbody>
          {#each playersStatic as player, index}
            <tr 
            on:click={() => toggleSelect(player.id)} 
              class:selected={selectedPlayers.includes(player.id)}
              style="cursor: pointer;">
              <td>{index + 1}</td>
              <td>{player.id}</td>
              <td>{player.username}</td>
              <td>{player?.username_origin} ({player?.firstname})</td>

              <td>{player.currency}</td>
              <td style="text-align: center;">
                <span>{selectedPlayers.includes(player.id) ? '✔️' : ''}</span>
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    
      <div class="freeSpin-modal">
        <table class="table table-sm" style="width: 100%;">
          <thead style="background-color:rgb(79 61 58); color: white;">
            <tr>
              <th scope="col">#</th>
              <th scope="col">ID external</th>
              <th scope="col">Username</th>
              <th scope="col">Currency</th>
              <th scope="col">Acion</th>
            </tr>
          </thead>
          <tbody>
            {#if isLoading}
              <tr>
                <td colspan="3" class="text-center">Cargando...</td>
              </tr>
            {:else if players.length === 0}
              <tr>
                <td colspan="3" class="text-center">Sin datos</td>
              </tr>
            {:else}
              {#each players as player, index}
              <tr>
                <td>{index + 1}</td>
                <td>{player.external_id}</td>
                <td>{player.username}</td>
                <td>{player.currency}</td>
                <td>

                  <div class="button-container">
                    <button
                      on:click={() => removePlayerOffCampaign(player.external_id)}  
                      class="btn btn-danger btn-sm" 
                      disabled={isDelete[player.external_id]}
                    >
                      {#if isDelete[player.external_id]}
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        loading...
                      {:else}
                        <i class="fa-solid fa-trash"></i> 
                      {/if}
                    </button>
                    
                    <button 
                    on:click={() => details(player.external_id)}
                    class="btn btn-secondary btn-sm"
                    title="Ver detalles"
                  >
                    <i class="fa-solid fa-eye"></i>
                  </button>
                  
                  </div>

                </td>
              </tr>
              {/each}
            {/if}
          </tbody>
        </table>
      </div>

   
    </ModalBody>
    <ModalFooter>
      <button class="btn btn-primary" on:click={savePlayers} disabled={isLoading}>
        {#if isLoading}
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Cargando...
        {:else}
          Guardar
        {/if}
      </button>
    </ModalFooter>
  </Modal>

  <Toaster  bind:message={toastMessage} bind:type={type} bind:show={isShowToast} />
  {#if isdetail}
 
  <DetailPlayer bind:isdetail campaignId={campaignId} playerId={playerId}/>
{/if}




  <style>
    /* Estilos para la tabla */
    table {
      border-collapse: collapse;
      width: 100%;
    }
  
    .table-sm {
      font-size: 0.9rem;
    }
    .selected {
    background-color: #c4c4c8; /* Color de fondo para la fila seleccionada */
  }
    
  </style>

  